import { REGIMENES, USOS_CFDI } from "../../lib/invoicing";

export const fCls = "w-full h-11 px-3 rounded-lg border border-[#111827]/15 bg-[#F8FAFC] text-sm focus:outline-none focus:ring-2 focus:ring-[#1F2937]";
export const lCls = "text-[11px] font-bold uppercase tracking-wider text-[#111827]/50";

export function FiscalClientFields({ value, onChange, prefix = "fc" }) {
  const set = (k) => (e) => onChange({ ...value, [k]: k === "rfc" ? e.target.value.toUpperCase().replace(/\s/g, "") : e.target.value });
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <label><span className={lCls}>RFC</span>
        <input data-testid={`${prefix}-rfc`} value={value.rfc} onChange={set("rfc")} maxLength={13} placeholder="XAXX010101000" className={`${fCls} font-mono`} /></label>
      <label><span className={lCls}>Código postal fiscal</span>
        <input data-testid={`${prefix}-zip`} value={value.tax_zip} onChange={set("tax_zip")} maxLength={5} inputMode="numeric" className={`${fCls} font-mono`} /></label>
      <label className="sm:col-span-2"><span className={lCls}>Razón social (como en la constancia, sin régimen societario)</span>
        <input data-testid={`${prefix}-name`} value={value.legal_name} onChange={set("legal_name")} className={fCls} /></label>
      <label><span className={lCls}>Régimen fiscal</span>
        <select data-testid={`${prefix}-regime`} value={value.fiscal_regime} onChange={set("fiscal_regime")} className={fCls}>
          {REGIMENES.map(([k, l]) => <option key={k} value={k}>{k} · {l}</option>)}
        </select></label>
      <label><span className={lCls}>Uso de CFDI</span>
        <select data-testid={`${prefix}-use`} value={value.cfdi_use} onChange={set("cfdi_use")} className={fCls}>
          {USOS_CFDI.map(([k, l]) => <option key={k} value={k}>{k} · {l}</option>)}
        </select></label>
      <label className="sm:col-span-2"><span className={lCls}>Correo para enviar la factura</span>
        <input data-testid={`${prefix}-email`} type="email" value={value.email} onChange={set("email")} className={fCls} /></label>
    </div>
  );
}

export function validClient(c) {
  if (!/^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/.test(c.rfc || "")) return "RFC inválido";
  if (!(c.legal_name || "").trim()) return "Captura la razón social";
  if (!/^\d{5}$/.test(c.tax_zip || "")) return "Código postal de 5 dígitos";
  return null;
}
